
import Vue from 'vue';

export default {
  state: {
    intentions: [],
    intentionFilters: [],
  },
  getters: {
    intention: state => id => state.intentions.find(item => item.id === id) || {},
    intentions(state) {
      return state.intentions;
    },
    intentionFilters(state) {
      return state.intentionFilters;
    },
  },
  mutations: {
    SET_INTENTIONS(state, payload) {
      state.intentions = payload;
    },
    UPDATE_INTENTIONS(state, payload) {
      payload.forEach((intent) => {
        const index = state.intentions.findIndex(item => item.id === intent.id);
        if (index >= 0) {
          state.intentions[index].qty = intent.qty;
        }
      });
    },
    SET_INTENTION_FILTERS(state, payload) {
      state.intentionFilters = payload;
    },
    CLEAR_INTENTIONS_FILTERS(state) {
      state.intentionFilters = [];
    },
  },
  actions: {
    //
    GET_INTENTIONS({ commit }) {
      Vue.axios('intentions').then(({ data }) => {
        commit('SET_INTENTIONS', data.map((item) => {
          // eslint-disable-next-line
          item.qty = 0;
          return item;
        }));
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/intentions.js